export default __webpack_public_path__ + "static/felipe-3ea4a0f9735a69c81a4e0865425fe5ff.jpg";